import React, { useEffect, useRef, useState } from "react"
import Slider from "react-slick"
import { aimlBreakPoints } from "../../utils/slider-utils"
import { Card } from "flowbite-react"
import ArrowButtons from "../../components/ArrowButtons"

const CustomSlider = ({ data, rows = 2 }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [slideToShow, setSlideToShow] = useState(0)
  const [totalSlide, setTotalSlide] = useState(0)
  const sliderRef = useRef(null)

  useEffect(() => {
    const slider = sliderRef.current
    if (slider) {
      const { slideCount, currentSlide, slidesToShow } =
        slider.innerSlider.track.props
      setTotalSlide(slideCount)
      setCurrentIndex(currentSlide)
      setSlideToShow(slidesToShow)
    }
  }, [totalSlide])

  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 2,
    initialSlide: 0,
    rows: rows,
    responsive: aimlBreakPoints,
    cssEase: "linear",
    arrows: false,
    centerMode: false,
    afterChange: current => {
      const { slidesToShow } = sliderRef.current.innerSlider.track.props
      setSlideToShow(slidesToShow)
      setCurrentIndex(current)
    },
  }

  const nextSlide = () => {
    sliderRef.current.slickNext()
  }

  const prevSlide = () => {
    sliderRef.current.slickPrev()
  }
  return (
    <div className="flex flex-col gap-12">
      <div className="flex  items-center gap-4 px-6 md:px-20 w-full justify-between">
        <div className="text-4xl md:text-6xl -tracking-[1.2px] md:-tracking-[4.2px] text-gray-100">
          {data.title}
        </div>
        <ArrowButtons
          theme={"dark"}
          nextDisabled={currentIndex >= totalSlide - slideToShow}
          prevDisabled={currentIndex === 0}
          nextClick={nextSlide}
          prevClick={prevSlide}
        />
      </div>
      <Slider
        className={` usecase-slider animate-fade  transition delay-500 `}
        ref={sliderRef}
        {...settings}
      >
        {data.features.map((item, index) => (
          <div key={index} className="px-4  py-4">
            <Card
              className=" rounded-[1.25rem] min-h-[230px] md:min-h-[300px] shadow-none border-none"
              theme={{
                root: {
                  children:
                    "flex h-full flex-col justify-center gap-2 md:gap-5 px-6 py-8",

                  href: "hover:bg-gray-100 dark:hover:bg-gray-700",
                },
              }}
            >
              <h6 className="text-3xl font-normal md:text-[2rem] -tracking-[0.96px] md:-tracking-[1.28px]  text-gray-100 ">
                {item.headline}
              </h6>
              {item.description && (
                <p className="text-base  text-black-300 md:-tracking-[0.32px]">
                  {item.description}
                </p>
              )}
            </Card>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default CustomSlider
